import  useTimeout  from '../hooks/UseTimeOut'; // Your custom hook
 // Your custom hook
import PropTypes from 'prop-types';
import { useState } from 'react';
import clsx from 'clsx';

function FuseLoading(props) {
    const [showLoading, setShowLoading] = useState(!props.delay);

    useTimeout(() => {
        setShowLoading(true);
    }, typeof props.delay === 'number' ? props.delay : 0);

    return (
        <div className={clsx('d-flex flex-column align-items-center justify-content-center p-3', !showLoading && 'd-none')}>
            <div className="text-muted mb-3">
                <h5>Loading</h5>
            </div>
            {/* Custom Loading Bar with left-to-right animation */}
            <div className="progress-container w-75">
                <div className="progress-bar-moving"></div>
            </div>

            {/* Inline CSS for the loading bar */}
            <style jsx>{`
                .progress-container {
                    position: relative;
                    background-color: #E0E0E0; /* Background for the progress track */
                    height: 8px;
                    border-radius: 4px;
                    overflow: hidden;
                }

                .progress-bar-moving {
                    height: 100%;
                    width: 30%; /* The width of the moving part of the progress bar */
                    background-color: #2E2E48; /* Desired color for the progress bar */
                    border-radius: 4px;
                    animation: move 1.5s infinite linear; /* Animation to move left to right */
                }

                @keyframes move {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }
            `}</style>
        </div>
    );
}

FuseLoading.propTypes = {
    delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
};

FuseLoading.defaultProps = {
    delay: false
};

export default FuseLoading;
